/**
 * Admin puzzle detail path for a speed-rank story.
 * Sliding → /admin/sliding/:storyId · Jigsaw → /admin/jigsaw/browse/:storyId
 */
export function speedRankPuzzleDetailPath(puzzleType, storyId) {
    if (!storyId) {
        return null;
    }
    const id = encodeURIComponent(String(storyId));
    const type = String(puzzleType || "").toUpperCase();
    if (type === "JIGSAW") {
        return `/admin/jigsaw/browse/${id}`;
    }
    if (type === "SLIDING") {
        return `/admin/sliding/${id}`;
    }
    return null;
}
